// extracted by mini-css-extract-plugin
module.exports = {"primary":"#438c2b","accent":"#e91e63","secondary":"#f0e513","tertiary":"#b4a734","success":"#438c2b","info":"#2196f3","warning":"#cf4f39","danger":"#fb8c00","error":"#e63838"};